// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-container[data-v-49d59549] {\n  display: flex;\n  justify-content: flex-end;\n}\n#btn-add-todas-tarefas-grupo[data-v-49d59549] {\n  margin-right: 5px;\n}\n.inValida[data-v-49d59549] {\n  border: 1px solid #a94442;\n}\n.mensagemDeErro[data-v-49d59549] {\n  height: 15px;\n  margin: 0 0 10px 0;\n  color: #a94442;\n  font-size: 12px;\n}\n.labelObrigatorio[data-v-49d59549] {\n  color: #a94442;\n}\n.label-grupo[data-v-49d59549] {\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
